import { render, staticRenderFns } from "./LicenseAgreement.vue?vue&type=template&id=09130021&"
import script from "./LicenseAgreement.vue?vue&type=script&lang=js&"
export * from "./LicenseAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports